import React from 'react';
import { Toggle } from '../../common/Toggle';
import { Checkbox } from 'react-bootstrap';

class TagCheck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: false,
    };
  }

  render() {
    return (
      <div className="remember-this">
        <div className="page-options float-left">
          <span
            className="icon icon-information"
            onClick={this.props.rememberThisIconClickOpen}
          />
          Remember this
        </div>

        <div className="toggle float-right">
          <Toggle
            defaultChecked={this.state.toggled}
            aria-label="No label tag"
            onChange={this.props.toggleCheckBox}
          />

          <Checkbox>
            <span />
          </Checkbox>
        </div>
      </div>
    );
  }
}

export default TagCheck;
